import { Result } from "../../core/helper/result";
export interface CurrentUser { id: string; username: string; role: "admin" | "student"; }
export class AuthorizationModel {
  constructor(public login = "", public password = "") {}
  isValid(): Result<string, void> {
    if (!this.login.trim()) return Result.error("Введите логин");
    if (!this.password) return Result.error("Введите пароль");
    return Result.ok();
  }
  static empty() { return new AuthorizationModel(); }
}
